import { createFileRoute } from '@tanstack/react-router';

import { AddExpensePage } from '@/areas/manufacturing-templates/Expenses/ExpensesCreation/AddExpensePage';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturing/expenses/create')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AddExpensePage />;
}
